import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';

interface DetailSection6Props {
  submission: CreditSubmission;
}

export default function DetailSection6({ submission }: DetailSection6Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>6. Alamat & Lokasi</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="text-sm text-gray-600">Alamat Lengkap</label>
            <p className="mt-1">{submission.address || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kelurahan</label>
            <p className="font-medium mt-1">{submission.village || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kecamatan</label>
            <p className="font-medium mt-1">{submission.district || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kota</label>
            <p className="font-medium mt-1">{submission.city || '-'}</p>
          </div>
          {submission.latitude && submission.longitude && (
            <>
              <div>
                <label className="text-sm text-gray-600">Latitude</label>
                <p className="font-medium mt-1">{submission.latitude}</p>
              </div>
              <div>
                <label className="text-sm text-gray-600">Longitude</label>
                <p className="font-medium mt-1">{submission.longitude}</p>
              </div>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
